import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { EditAdminAccountModalContent } from './content';
import { SimpleModal, BackdropLoader } from '@livable/saas-react-components';
import { observer } from 'mobx-react-lite';
export const EditAdminAccountModal = observer(_ref => {
  let customTrigger = _ref.customTrigger,
    data = _ref.data,
    handleTriggerShowModal = _ref.handleTriggerShowModal,
    handleShowModal = _ref.handleShowModal,
    triggerRefresh = _ref.triggerRefresh;
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    modalIsOpen = _useState4[0],
    setModalIsOpen = _useState4[1];
  const handleOpenModal = () => {
    setModalIsOpen(true);
  };
  const handleEditModalSuccess = () => {
    setModalIsOpen(false);
  };
  useEffect(() => {
    if (handleTriggerShowModal) {
      handleOpenModal();
      handleShowModal(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [handleTriggerShowModal]);
  return /*#__PURE__*/React.createElement(SimpleModal, {
    trigger: customTrigger !== undefined ? customTrigger : internalTrigger,
    isOpen: modalIsOpen,
    handleClose: () => setModalIsOpen(false),
    title: t('admin_page.edit_admin_account'),
    subTitle: (data === null || data === void 0 ? void 0 : data.email) || (data === null || data === void 0 ? void 0 : data.newEmail),
    noFooter: true,
    noPadding: true
  }, /*#__PURE__*/React.createElement(EditAdminAccountModalContent, {
    data: data,
    handleEditModalSuccess: handleEditModalSuccess,
    handleModalClose: () => setModalIsOpen(false),
    setIsLoading: setIsLoading,
    triggerRefresh: triggerRefresh
  }), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isLoading
  }));
});